



































































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';
import BankAccountModule from '@/store/modules/BankAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Mixins(ErrorHandleMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly startdate: any;

  @Prop() readonly enddate: any;

  @Prop() readonly data: any;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  utilsInstance = utils;

  checkTransaction = [];

  accountBank = [];

  filterSelectedBank = [];

  handleSub(username, role, source, id) {
    this.fetchWinloseAgent(username, role, source, id);
  }
}
